<template>
  <div>
    <div class="header mb-4">
      <h1 class="header-title">Order Management</h1>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'home' }">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">My Orders</li>
        </ol>
      </nav>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="!loading">
            <div class="row justify-content-between mb-3">
              <div class="col-md-4">
                <select class="form-control" v-model="search.status" @change="fetch">
                  <option value="pending">Pending Orders</option>
                  <option value="in-progress">In Progress Orders</option>
                  <option value="complete">Completed Orders</option>
                  <option value="cancelled">Cancelled Orders</option>
                  <option value="all">All Orders</option>
                </select>
              </div>
              <div class="col-md-4">
                <div class="input-group password-input">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search order no. title..."
                    v-model="search.term"
                  />
                  <button class="btn" @click.prevent="search.term = ''" v-if="search.term.length > 0">
                    <i class="fal me-0 fa-times"></i>
                  </button>
                  <button class="btn" @click.prevent="fetch">
                    <i class="fal me-0 fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <table class="table">
              <thead>
                <tr>
                  <th>Order No.</th>
                  <th>Title</th>
                  <th>Type</th>
                  <th>Category</th>
                  <th>Quality</th>
                  <th>Words</th>
                  <th>Price</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="orders.length == 0">
                  <td colspan="8">There is no data to display.</td>
                </tr>
                <tr v-for="(order, i) in orders" :key="`order-${i}`">
                  <td>
                    <router-link
                      class="text-primary"
                      :to="{
                        name: 'admin.orders.show',
                        params: { id: order.id },
                      }"
                      >{{ order.id }}</router-link
                    >
                  </td>
                  <td>
                    <router-link
                      class="text-primary"
                      :to="{
                        name: 'admin.orders.show',
                        params: { id: order.id },
                      }"
                      >{{ order.title }}</router-link
                    >
                  </td>
                  <td>{{ order.type }}</td>
                  <td>{{ order.category }}</td>
                  <td width="120px">
                    <quality :quality="{ stars: order.stars }" />
                    <span>{{ order.quality }}</span>
                  </td>
                  <td>{{ order.min }} - {{ order.max }}</td>
                  <td>{{ order.price }}</td>
                  <td>{{ order.status }}</td>
                </tr>
              </tbody>
            </table>
            <pagination v-model="pagination.page" :records="pagination.records" @paginate="fetch" />
          </div>
          <loading v-if="loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    if(this.$route.query.status) {
      this.search.status = this.$route.query.status
    }

    if(this.$route.query.term) {
      this.search.term = this.$route.query.term
    }

    if(this.$route.query.page) {
      this.pagination.page = this.$route.query.page
    }

    this.fetch();
  },

  data() {
    return {
      orders: [],
      loading: true,
      search: { status: 'pending', term: '' },
      pagination: {
        page: 1,
        records: 0
      }
    };
  },

  methods: {
    fetch() {
      this.$router.push({ query: { status: this.search.status, term: this.search.term, page: this.pagination.page }})
      
      this.loading = true;

      this.$axios.get(`/api/v1/admin/orders?status=${this.search.status}&term=${this.search.term}&page=${this.pagination.page}`).then((response) => {
        this.orders = response.data.orders;
        this.pagination = response.data.pagination;
        this.loading = false;
      });
    },
  },
};
</script>
